module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "has-text-centered"
  }, [_vm._v("Öldrickartoppen")]), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.orderBy(_vm.topDrinkers, 'count', 'desc').slice(0, _vm.drinkersInList)), function(topDrinker, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(topDrinker.name))]), _vm._v(" "), _c('td', {
      staticClass: "has-text-centered"
    }, [_vm._v(_vm._s(topDrinker.count))])])
  })), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "has-text-right is-size-7 is-uppercase",
    attrs: {
      "colspan": "2"
    }
  }, [_c('a', {
    on: {
      "click": _vm.toggleDrinkersInList
    }
  }, [_vm._v(_vm._s(_vm.drinkersInListButtonTxt))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "beers-data__header"
  }, [_c('th', [_vm._v("Namn")]), _vm._v(" "), _c('th', {
    staticClass: "has-text-centered",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Antal")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-aa9e92a0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa9e92a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/facts/TopDrinkers.vue
// module id = 155
// module chunks = 1